<template>
  <div>
    <div class="col-lg-12">
      <div class="ibox">
        <div class="ibox-title">Auto fulfil</div>
      <div class="ibox-content">
        <table class="table small table-striped table-bordered">
          <thead>
          <tr>
            <th>Search</th>
            <th>Link</th>
            <th align="center">Deploy At</th>
            <th align="center">Status</th>
            <th>
              <!--                                <button class="button btn-xs btn-primary" data-toggle="modal" data-target="#modal-replace">Add</button>-->
              <button class="button btn-xs btn-primary" data-toggle="modal" data-target="#modal-upload-csv">CSV</button>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(order, index) in this.autoReplaceOrders" v-bind:key="index">
            <td>{{ order.search.join(',') }}</td>
            <td>{{ order.link.slice(0, 100) }}{{ order.link.length > 100 ? '...' : '' }}</td>
            <td>{{ $moment(order.deployAt.date).format('DD.MM.YYYY HH:mm') }}</td>
            <td align="center">
              <i v-if="order.status === 'fulfilled'" class="fa fa-check" style="color: green;" v-bind:title="order.status"></i>
              <i v-else-if="order.status === 'created'" class="fa fa-ellipsis-h" style="color: orange;" v-bind:title="order.status"></i>
              <i v-else class="fa fa-clock-o" style="color: orange;" v-bind:title="order.status"></i>
              <!--                                {{ order.status }}-->
            </td>
            <td align="center">
              <i v-if="order.status !== 'fulfilled'" class="fa fa-remove" style="color: red; cursor: pointer;" @click="deleteReplacement(order.id)" alt="Remove"></i>
            </td>
          </tr>
          </tbody>
        </table>
        <button class="btn-primary btn" @click="previewFulfilment">Fulfil order</button>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AutoFulfilOrders',
  props: ['autoReplaceOrders'],
  data () {
    return {
    }
  },
  methods: {
    deleteReplacement (order) {
      return false
    },
    previewFulfilment () {
      this.$emit('previewFulfilment')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Client/AutoFulfilOrders.vue